// extracted by mini-css-extract-plugin
export default {"cell":"newTableCells-module__cell___sWNkQ"};